"use strict";

/**
 * The languages the app names, by their endonyms: each language names itself, so the names do
 * not change with the active locale.
 *
 * One table for the booking pages (src/libs/LanguageUtil.js) and the order confirmation e-mail
 * (EmailNotif), so the e-mail names a lesson language as the pages do (MOB-322). The table used
 * to be copied into all six locale files (MOB-129), and the e-mail looked up the upper-case
 * `Language` enum value in the lower-case keys of the layer locale files and printed the raw code.
 *
 * This module has no `require`, so the `layerCjsToEsm` plugin of vite.config.js serves it to the
 * app (ADR 0011).
 */
const LANGUAGE_LABELS = {
  cs: "Česky",
  sk: "Slovensky",
  de: "Deutsch",
  en: "English",
  hu: "Magyarul",
  pl: "Polski",
  fr: "Français",
  es: "Español",
  da: "Dansk",
  ua: "УКРАЇНСЬКА",
  ru: "ПО-РУССКИ",
};

/**
 * The display name of one language code.
 *
 * Case- and whitespace-insensitive: the UI works in lower-case codes while the backend stores
 * upper-case ones. An unknown code is returned unchanged. A missing code renders as nothing.
 *
 * @param {string} code - ISO 639-1 code, any case
 * @returns {string}
 */
function label(code) {
  if (code === null || code === undefined) {
    return "";
  }
  const key = String(code).trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(LANGUAGE_LABELS, key) ? LANGUAGE_LABELS[key] : String(code);
}

const LanguageLabels = {
  LANGUAGE_LABELS,
  label,
};

module.exports = LanguageLabels;
